
import { Footer } from "../../Footer/Footer"
import { Header } from "../Header/Header"
import { useEffect, useState } from "react"
import { ExamPopUp } from "./ExamPopUp"
import { OptionalSubject } from "./OptionalSubject"
import { LicentiateCertificateDDL } from "../../CommonDDL/LicentiateCertificateDDL"
import { LicentiateCertificateSubMenuDDL } from "../../CommonDDL/LicentiateCertificateSubMenuDDL"
import { OpenPopUp } from "./OpenPopUp"
import { PrincipleOfInsurance } from "./PrincipleOfInsurance"
import { MarineHullInsuranceUnderwritingandClaimsTable } from "./MarineHullInsuranceUnderwritingandClaimsTable"
import { AccountsPreparationsAndInvestmentRegulationTable } from "./AccountsPreparationsAndInvestmentRegulationTable"
import { PracticeofGeneralInsuranceTable } from "./PracticeofGeneralInsuranceTable"

export const ExaminationStructure = () => {

    const [SelectedSubID, setSelectedSubID] = useState(0)
    const [showpopup, setshowpopup] = useState(false)
    const [SelectedSubName, setSelectedSubName] = useState("")
    const handleshowpopup = () => {
        setshowpopup(false)
    }


    const [LicentiateCertificateID, setLicentiateCertificateID] = useState({
        DDL: [],
        ID: 0,
        Label: "Please Select",
    })
    const [LicentiateCertificateSubMenuID, setLicentiateCertificateSubMenuID] = useState({
        DDL: [],
        ID: 0,
        Label: "Please Select",
    })


    // reset optional subject when changes
    useEffect(() => {
        setSelectedSubID(0);
    }, [LicentiateCertificateSubMenuID, LicentiateCertificateID]);

    return (
        <>
            <div className="container-fluid">
                <div className="row" onLoad={() => window.scrollTo(0, 0)} style={{ background: '#ececec' }}>
                    <div className="col-12">
                        <Header actives="Home" />

                        <div className="row col-lg-11 mx-auto mt-5 mb-4 py-lg-5">

                            <div className="col-12  text-center d-flex justify-content-center  mt-3" style={{ flexDirection: 'column' }} >
                                <h3 className="fw-bold pt-5 pt-lg-2 pb-lg-3"
                                    style={{
                                        color: '#cd9e53'
                                    }}
                                > Insurance Institute of India Examinations  </h3>
                            </div>

                            {/* flyer image */}
                            <div className="row justify-content-center">
                                <div className="text-center py-5 rounded"
                                    style={{
                                        backgroundColor: '#16374e',
                                        width: '100%'
                                    }}
                                >
                                    <img src="Static/Assets/Img/Banner/flyerimage2.jpeg" alt="image not found" className=""
                                        style={{
                                            maxHeight: '650px',
                                            boxShadow: '10px 10px #cd9e53'
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="row mt-3 rounded" style={{ background: "#cd9e53" }}>
                                <div className="col-12 col-lg-5 mx-auto py-5">
                                    <label className=" mb-1">Select Exam :</label>
                                    <div className=" examination_height bg-white">
                                        <LicentiateCertificateDDL
                                            LicentiateCertificateID={LicentiateCertificateID}
                                            setLicentiateCertificateID={setLicentiateCertificateID}
                                            M_MainSubjectID={0}
                                            M_UserID={0}
                                            Flag="Master"
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-lg-5 mx-auto py-5">
                                    <label className=" mb-1">Select Subject :</label>
                                    <div className=" examination_height bg-white">
                                        <LicentiateCertificateSubMenuDDL
                                            LicentiateCertificateSubMenuID={LicentiateCertificateSubMenuID}
                                            setLicentiateCertificateSubMenuID={setLicentiateCertificateSubMenuID}
                                            M_MainSubjectID={LicentiateCertificateID.ID}
                                            M_UserID={0}
                                            Flag="SubSubject_Master"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2 border rounded px-0"
                                style={{
                                    backgroundColor:"#cfcfcfff",
                                    // maxHeight:'90%'
                                }}
                            >
                                <div>
                                    {
                                        LicentiateCertificateSubMenuID?.ID == 1 ?
                                            < PrincipleOfInsurance /> : ''
                                    } 
                                    {
                                        LicentiateCertificateSubMenuID?.ID == 14 ?
                                            < MarineHullInsuranceUnderwritingandClaimsTable /> : ''
                                    }
                                    {
                                        LicentiateCertificateSubMenuID?.ID == 5 ?
                                            < AccountsPreparationsAndInvestmentRegulationTable /> : ''
                                    }
                                    {
                                        LicentiateCertificateSubMenuID?.ID == 2 ?
                                            < PracticeofGeneralInsuranceTable /> : ''
                                    }
                                </div>
                            </div>

                            <div className="row mt-2 px-0">
                                {(LicentiateCertificateSubMenuID.Label === "Optional Subject") ?

                                    <OptionalSubject
                                        SelectedSubID={SelectedSubID}
                                        setSelectedSubID={setSelectedSubID}
                                        LicentiateCertificateID={LicentiateCertificateID.ID}
                                        LicentiateCertificateSubMenuID={LicentiateCertificateSubMenuID.ID}
                                        SelectedSubName={SelectedSubName}
                                        setSelectedSubName={setSelectedSubName} />

                                    : LicentiateCertificateSubMenuID.ID != "0"
                                        ?
                                        <OpenPopUp
                                            LicentiateCertificateID={LicentiateCertificateID.ID}
                                            LicentiateCertificateSubMenuID={LicentiateCertificateSubMenuID.ID}
                                            SelectedSubName={LicentiateCertificateSubMenuID.Label}

                                        />
                                        :
                                        <></>}

                            </div>

                        </div>
                    </div>
                    {/* <BookOnline /> */}
                    <Footer />

                </div>

            </div>

            {
                showpopup ?
                    <ExamPopUp
                        cancelbtn={handleshowpopup}
                        heading="Enrollment Form"
                    /> :
                    <></>

            }


        </>
    )
}